export const SET_IDEMPOTENCY_KEY = "idempotencyKey/SET_IDEMPOTENCY_KEY";
export const CLEAR_IDEMPOTENCY_KEY = "idempotencyKey/CLEAR_IDEMPOTENCY_KEY";
